import React, { Component } from "react";
import Modal from "@cloudscape-design/components/modal";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import Select from "@cloudscape-design/components/select";
import SpaceBetween from "@cloudscape-design/components/space-between";
import FormField from "@cloudscape-design/components/form-field";
import Alert from "@cloudscape-design/components/alert";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { gamesAllEditModalStore } from "../stores/gamesAllEditModal";
import { providerStore } from "../stores/provider";
import { gameStore } from "../stores/games";
import Multiselect from "@cloudscape-design/components/multiselect";
import { configStore } from "../stores/config";
class GamesAllEditModal extends Component {
	constructor(props) {
		super(props);
	}

	editGame = async () => {
		const { gamesAllEditModal, setGamesAllEditModal, Interface, game, setGame } = this.props;
		setGamesAllEditModal({ ...gamesAllEditModal, loaded: false });

		try {
			const listedValue = gamesAllEditModal.values.listed?.value;
			const activeValue = gamesAllEditModal.values.active?.value;
			const hasListedUpdate = typeof listedValue === "boolean";
			const hasActiveUpdate = typeof activeValue === "boolean";
			const hasCategoryUpdate = Array.isArray(gamesAllEditModal.values.categoryID);
			const categoryID = hasCategoryUpdate ? gamesAllEditModal.values.categoryID.map(({ type }) => type) : null;
			const updates = gamesAllEditModal.selectedItems.map(({ gameID }) => {
				const update = { id: gameID };

				if (hasListedUpdate) update.listed = listedValue;
				if (hasActiveUpdate) update.active = activeValue;
				if (hasCategoryUpdate) update.categoryID = categoryID;

				return update;
			});

			await Interface.request("set", { class: "data", module: "games", method: "bulkEdit" }, { updates });

			const updatesById = new Map(updates.map((update) => [Number(update.id), update]));
			const data = game.data.map((item) => {
				const update = updatesById.get(Number(item.gameID));
				if (!update) return item;

				return {
					...item,
					active: typeof update.active === "boolean" ? (update.active ? 1 : 0) : item.active,
					categoryID: Array.isArray(update.categoryID) ? update.categoryID : item.categoryID,
					listed: typeof update.listed === "boolean" ? (update.listed ? 1 : 0) : item.listed,
				};
			});

			Interface.addNoty("Success", "Games were successfully edited");
			setGamesAllEditModal({ ...gamesAllEditModal, loaded: true, show: false, selectedItems: [] });
			setGame({ ...game, data, selectedItems: [] });
		} catch (error) {
			Interface.addNoty("Error", error.text || error.toString());
			setGamesAllEditModal({
				...gamesAllEditModal,
				loaded: true,
				error: {
					text: error.text || error.toString(),
					code: error.code || 500,
					timestamp: Date.now(),
				},
			});
		}
	};



	render() {
		const { gamesAllEditModal, setGamesAllEditModal, config } = this.props;

		return (
			<Modal
				visible={gamesAllEditModal.show}
				onDismiss={() =>
					setGamesAllEditModal({
						...gamesAllEditModal,
						show: false,
						error: { text: "", code: 0, timestamp: 0 },
					})
				}
				header="Edit Games"
				footer={
					<Box float="right">
						<SpaceBetween direction="horizontal" size="xs">
							<Button
								variant="link"
								onClick={() =>
									setGamesAllEditModal({
										...gamesAllEditModal,
										show: false,
										error: { text: "", code: 0, timestamp: 0 },
									})
								}
							>
								Cancel
							</Button>
							<Button
								variant="primary"
								onClick={this.editGame}
								loading={!gamesAllEditModal.loaded}
								disabled={!gamesAllEditModal.loaded || gamesAllEditModal.selectedItems.length === 0}
							>
								Save Changes
							</Button>
						</SpaceBetween>
					</Box>
				}
			>
				<SpaceBetween size="m">
					{gamesAllEditModal.error.text && (
						<Alert type="error" children={gamesAllEditModal.error.text} />
					)}
					<FormField label="Category id">
						<Multiselect
							filteringType="auto"
							selectedOptions={gamesAllEditModal.values.categoryID ? gamesAllEditModal.values.categoryID : []}
							onChange={(select) => {
								setGamesAllEditModal({
									...gamesAllEditModal,
									values: {
										...gamesAllEditModal.values,
										categoryID: select.detail.selectedOptions,
									}
								});
							}}
							disabled={!gamesAllEditModal.loaded}
							placeholder="Category"
							options={config.game.options.category.slice(1)}
						/>
					</FormField>
					<FormField label="Listed">
						<Select
							selectedOption={gamesAllEditModal.values.listed}
							onChange={({ detail }) => {
								setGamesAllEditModal({
									...gamesAllEditModal,
									values: {
										...gamesAllEditModal.values,
										listed: detail.selectedOption,
									}
								});
							}}
							options={[
								{ value: null, label: "Keep current" },
								{ value: true, label: "True" },
								{ value: false, label: "False" },
							]}
							placeholder="Choose listed status"
							disabled={!gamesAllEditModal.loaded || gamesAllEditModal.selectedItems.length === 0}
						/>
					</FormField>
					<FormField label="Active">
						<Select
							selectedOption={gamesAllEditModal.values.active}
							onChange={({ detail }) => {
								setGamesAllEditModal({
									...gamesAllEditModal,
									values: {
										...gamesAllEditModal.values,
										active: detail.selectedOption,
									}
								});
							}}
							options={[
								{ value: null, label: "Keep current" },
								{ value: true, label: "True" },
								{ value: false, label: "False" },
							]}
							placeholder="Choose active status"
							disabled={!gamesAllEditModal.loaded || gamesAllEditModal.selectedItems.length === 0}
						/>
					</FormField>
				</SpaceBetween>
			</Modal>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const gamesAllEditModal = useRecoilValue(gamesAllEditModalStore);
		const setGamesAllEditModal = useSetRecoilState(gamesAllEditModalStore);
		const provider = useRecoilValue(providerStore)
		const game = useRecoilValue(gameStore);
		const setGame = useSetRecoilState(gameStore);
		const config = useRecoilValue(configStore);

		return (
			<Component
				{...props}
				game={game}
				config={config}
				setGame={setGame}
				provider={provider}
				setGamesAllEditModal={setGamesAllEditModal}
				gamesAllEditModal={gamesAllEditModal}
			/>
		);
	};
}

export default withRecoil(GamesAllEditModal);
